module.exports = __webpack_public_path__ + "img/ctt-expresso.39dafa88.png";